import { render } from "./GtrSystem.vue?vue&type=template&id=572af13d&ts=true"
import script from "./GtrSystem.vue?vue&type=script&lang=ts"
export * from "./GtrSystem.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__